import * as React from "react";
const SvgFiRrCryptocurrency = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cryptocurrency_svg__a)">
      <path
        fill="#062147"
        d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10M9.171 9.171A3.98 3.98 0 0 0 8 12c0 1.069.416 2.073 1.171 2.829a4.004 4.004 0 0 0 5.657 0 .999.999 0 1 1 1.414 1.414 5.94 5.94 0 0 1-3.243 1.659V19a1 1 0 0 1-2 0v-1.098a5.95 5.95 0 0 1-3.243-1.659 6.007 6.007 0 0 1 0-8.485 5.94 5.94 0 0 1 3.243-1.659V5.001a1 1 0 0 1 2 0v1.098a5.95 5.95 0 0 1 3.243 1.659.999.999 0 1 1-1.414 1.414 4.004 4.004 0 0 0-5.657 0z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cryptocurrency_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCryptocurrency;
